import { useEffect } from "react";
import useUiDispatch from "@/hooks/useUiDispatch";
import { setErrorDispatch } from "@/lib/queryClient";
import { showToast } from "@/lib/ui/actions/actions";

export default function QueryClientInitializer({ children }) {
  const dispatch = useUiDispatch();

  useEffect(() => {
    setErrorDispatch((toast) => dispatch(showToast(toast)));
  }, [dispatch]);

  return children;
}
